import template from "./hb-header.mjs";
import { render } from "lit-html";
import { User } from "firebase/auth";

import { HbPasskey } from "./hb-passkey/hb-passkey.ts";
import { HbLockbox } from "./hb-lockbox/hb-lockbox.ts";
import { HbLocker } from "./hb-locker/hb-locker.ts";
import { HbSafe } from "./hb-safe/hb-safe.ts";
import { HbHold } from "./hb-hold/hb-hold.ts";

import { HbMenu } from "./hb-menu/hb-menu.ts";
import { HbNavBar } from "./hb-navbar/hb-navbar.ts";
import { HbChest } from "./hb-chest/hb-chest.ts";
import { HbOnboard } from "./hb-onboard/hb-onboard.ts";
import { HbFactory } from "./hb-factory/hb-factory.ts";

customElements.define("hb-menu", HbMenu);
customElements.define("hb-navbar", HbNavBar);
customElements.define("hb-chest", HbChest);
customElements.define("hb-onboard", HbOnboard);
customElements.define("hb-factory", HbFactory);

customElements.define("hb-passkey", HbPasskey);
customElements.define("hb-lockbox", HbLockbox);
customElements.define("hb-locker", HbLocker);
customElements.define("hb-safe", HbSafe);
customElements.define("hb-hold", HbHold);

export class HbHeader extends HTMLElement {
    private menu: HbMenu;
    private navbar: HbNavBar;
    private chest: HbChest;
    private onboard: HbOnboard;
    private factory: HbFactory;

    private passkey: HbPasskey;
    private lockbox: HbLockbox;
    private locker: HbLocker;
    private safe: HbSafe;
    private hold: HbHold;

    constructor() {
        super();
        render(template(null), this);

        this.menu = this.querySelector("hb-menu")!;
        this.navbar = this.querySelector("hb-navbar")!;
        this.chest = this.querySelector("hb-chest")!;
        this.onboard = this.querySelector("hb-onboard")!;
        this.factory = this.querySelector("hb-factory")!;

        this.passkey = this.querySelector("hb-passkey")!;
        this.lockbox = this.querySelector("hb-lockbox")!;
        this.locker = this.querySelector("hb-locker")!;
        this.safe = this.querySelector("hb-safe")!;
        this.hold = this.querySelector("hb-hold")!;
    }

    login() {
        this.passkey.login();
    }

    logout() {
        this.passkey.logout();
    }

    sign() {
        const params = new URLSearchParams(window.location.search);
        const content = params.get("content") || "";
        this.passkey.sign(content);
    }

    encrypt() {
        const params = new URLSearchParams(window.location.search);
        const content = params.get("content") || "";
        this.passkey.encrypt(content);
    }

    decrypt() {
        const params = new URLSearchParams(window.location.search);
        const kid = params.get("kid") || "";
        const iv = params.get("iv") || "";
        const encryptedSymmetricKey = params.get("encryptedSymmetricKey") || "";
        const encryptedContent = params.get("encryptedContent") || "";
        const signature = params.get("signature") || "";

        this.passkey.decrypt(
            kid,
            iv,
            encryptedSymmetricKey,
            encryptedContent,
            signature
        );
    }

    showLockbox() {
        this.lockbox.show();
    }

    hideLockbox() {
        this.lockbox.hide();
    }

    renderLockbox(user: User | null) {
        this.lockbox.render(user);
    }

    showLocker() {
        this.locker.show();
    }

    hideLocker() {
        this.locker.hide();
    }

    showSafe() {
        this.safe.show();
    }

    hideSafe() {
        this.safe.hide();
    }

    renderSafe(user: User) {
        this.safe.render(user);
    }

    showHold() {
        this.hold.show();
    }

    hideHold() {
        this.hold.hide();
    }

    showMenu() {
        this.menu.show();
    }

    hideMenu() {
        this.menu.hide();
    }

    renderMenu() {
        this.menu.render();
    }

    showNavbar() {
        this.navbar.show();
    }

    hideNavbar() {
        this.navbar.hide();
    }

    showChest(id: string, source: string) {
        this.chest.show(id, source);
    }

    hideChest() {
        this.chest.hide();
    }

    showOnboard(page: string) {
        this.onboard.show(page);
    }

    hideOnboard() {
        this.onboard.hide();
    }

    showFactory() {
        this.factory.show();
    }

    hideFactory() {
        this.factory.hide();
    }
}
